<template>
  <div class="material-detalle">
    <el-row :gutter="12">
      <el-col
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Cantidad total</span>
          <span class="data-value">{{ dv(material.cantidad, unidadMedida) }}</span>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Merma</span>
          <span class="data-value merma-text">{{ dv(material.cantidadMerma, unidadMedida) }}</span>
        </div>
      </el-col>
      <el-col
        v-if="material.cantidadMermaMinima > 0"
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Merma mínima</span>
          <span class="data-value merma-text">{{
            dv(material.cantidadMermaMinima, unidadMedida)
          }}</span>
        </div>
      </el-col>
      <el-col
        v-if="material.gramaje"
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Gramaje</span>
          <span class="data-value">{{ dv(material.gramaje, 'g/m2') }}</span>
        </div>
      </el-col>
      <el-col
        v-if="material.densidad"
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Densidad</span>
          <span class="data-value">{{ dv(material.densidad, 'g/cm3') }}</span>
        </div>
      </el-col>
      <el-col
        v-if="material.espesor"
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Espesor</span>
          <span class="data-value">{{ dv(material.espesor, 'micras', 0) }}</span>
        </div>
      </el-col>
      <el-col
        v-if="material.kilosPorPliego"
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Kg/pliego</span>
          <span class="data-value">{{ dv(material.kilosPorPliego, 'kg', 4) }}</span>
        </div>
      </el-col>
      <el-col
        v-if="material.esTinta && material.rendimiento"
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Rendimiento</span>
          <span class="data-value">{{ dv(material.rendimiento, 'g/m2') }}</span>
        </div>
      </el-col>
      <el-col
        v-if="material.esTinta && material.cobertura"
        :xs="12"
        :sm="8"
        :md="6"
      >
        <div class="data-item">
          <span class="data-label">Cobertura</span>
          <span class="data-value">{{ dp(material.cobertura / 100) }}</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import {
  displayValueConUnidad,
  displayPorcentaje,
} from '@/shared/utils/format_produccion.js';

const props = defineProps({
  material: {
    type: Object,
    required: true,
  },
  isStale: {
    type: Boolean,
    default: false,
  },
});

const unidadMedida = computed(() => {
  const unidad = props.material.unidadMedida || '';
  const map = {
    KILOGRAMOS: 'kg',
    METROS_CUADRADOS: 'm2',
    METROS_LINEALES: 'm',
    UNIDADES: 'u',
    GRAMOS: 'g',
  };
  return map[unidad] || unidad.toLowerCase();
});

function dv(valor, unidad, decimales = 2) {
  return displayValueConUnidad(valor, unidad, props.isStale, decimales);
}

function dp(valor) {
  return displayPorcentaje(valor, props.isStale);
}
</script>

<style scoped>
.material-detalle {
  padding: 8px 0;
}

.data-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 0;
}

.data-label {
  font-size: 11px;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.data-value {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  font-family: 'Fira Code', monospace;
}

.merma-text {
  color: #e6a23c;
}
</style>
